import { Tag } from './user-tag.reducer';
import { SantanderTagValue, UserTagKey } from './user-tag-key.enum';

/**
 * Verifica se o usuário é um cliente originado/tombado do Santander
 *
 * Regras (equivalentes à referência do app mobile):
 *  - `imported_channel` === `santander027`
 *  - `registration_channel` === `simplificadosantander`
 *  - `campaign` === `santanderprivate`
 *
 * Basta uma das regras ser verdadeira para considerar o cliente como Santander.
 */
export function isSantanderCustomer(tags: Tag[] | null | undefined): boolean {
  if (!Array.isArray(tags) || tags.length === 0) {
    return false;
  }

  return tags.some((tag) => {
    if (!tag || !tag.key) {
      return false;
    }

    const value = (tag.value ?? '').toString().toLowerCase();

    switch (tag.key) {
      case UserTagKey.IMPORTED_CHANNEL:
        return value === SantanderTagValue.IMPORTED_CHANNEL;
      case UserTagKey.REGISTRATION_CHANNEL:
        return value === SantanderTagValue.REGISTRATION_CHANNEL;
      case UserTagKey.CAMPAIGN:
        return value === SantanderTagValue.CAMPAIGN;
      default:
        return false;
    }
  });
}
